import { addQuestionToSurvey } from '../Reducks/Survey/actions';
import * as transcriptActions from '../Reducks/Transcript/actions';
import Action from '../Mixpanel/Model/action';
import MixpanelTracker from '../Mixpanel/mixpanelTracker';
import trackAppcues from '../Mixpanel/Features/Appcues/appcuesTracker';
import { CREATE_WEBINAR_SURVEY_COMPLETE, DELETE_WEBINAR_SURVEY_COMPLETE } from '../Reducks/Survey/constants';
import { get } from '../Utils/objectHelpers';
import { reportAppcuesEventAction } from '../Reducks/Appcues/actions';
import { setEventCompactView } from '../Reducks/Ui/actions';
import { updateOrganizerWebinarSettingsAction, trackPaymentTosClickedAction, trackPaymentConnectToStripeClickedAction } from '../Reducks/AccountSettings/actions';

import { EVENT_DETAILS,
  ENGAGEMENT,
  PAYMENT_CONNECT_TO_STRIPE,
  PAYMENT_TOS,
  SETTINGS,
  SURVEY,
  TRANSCRIPT,
  WEBINAR } from '../Mixpanel/mixpanelConstants';

const mixpanelTracker = new MixpanelTracker();

const track = (name, properties) => {
  mixpanelTracker.setEventName(name);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
};

const mixpanelMiddleware = () => (next) => (action) => {
  switch (action.type) {
    case String(addQuestionToSurvey): {
      track(
        EVENT_DETAILS,
        {
          Action: Action.ADD,
          Type: ENGAGEMENT,
          Feature: SURVEY,
          'Question Type': get(action, (a) => a.payload.question.type)
        }
      );
      break;
    }
    case CREATE_WEBINAR_SURVEY_COMPLETE: {
      track(
        EVENT_DETAILS,
        {
          Action: Action.SAVE,
          Type: ENGAGEMENT,
          Feature: SURVEY
        }
      );
      break;
    }
    case DELETE_WEBINAR_SURVEY_COMPLETE: {
      track(
        EVENT_DETAILS,
        {
          Action: Action.REMOVE,
          Type: ENGAGEMENT,
          Feature: SURVEY
        }
      );
      break;
    }
    case String(setEventCompactView.fulfilled): {
      track(
        WEBINAR,
        {
          Action: Action.VIEW_MODE_CHANGE,
          'Compact View': action.payload.isCompactView
        }
      );
      break;
    }
    case String(transcriptActions.createTranscript.fulfilled): {
      track(
        TRANSCRIPT,
        {
          Action: 'Transcript Created',
          assetKey: get(action, (a) => a.payload.assetKey)
        }
      );
      break;
    }
    case String(updateOrganizerWebinarSettingsAction.complete): {
      if (Object.prototype.hasOwnProperty.call(action.data, 'autogenerateTranscriptsEnabled')) {
        track(
          TRANSCRIPT,
          {
            Action: 'Update Settings',
            autoGenerate: get(action, (a) => a.data.autogenerateTranscriptsEnabled)
          }
        );
      }
      break;
    }
    // TODO:FIX This belongs in the AppCues middleware
    case String(reportAppcuesEventAction): {
      trackAppcues(action.payload.name, action.payload.event);
      break;
    }
    case String(trackPaymentTosClickedAction): {
      track(
        SETTINGS,
        {
          Action: Action.CLICK,
          Type: `${PAYMENT_TOS}`
        }
      );
      break;
    }
    case String(trackPaymentConnectToStripeClickedAction): {
      track(
        SETTINGS,
        {
          Action: Action.CLICK,
          Type: `${PAYMENT_CONNECT_TO_STRIPE}`
        }
      );
      break;
    }
    default: return next(action);
  }

  return next(action);
};

export default mixpanelMiddleware;
